import { splitFiltersFromQueryParamString } from "@faire/deprecated-retailer-visitor-shared/filters/splitFiltersFromQueryParams";
import type { ISearchMakerProductsRequest } from "@faire/web-api--source/indigofair/data/ISearchMakerProductsRequest";
import qs from "query-string";

export const BRAND_PAGE_SAMPLE_REQUEST_MODAL_TYPE = "sampleRequest";
export const BRAND_PAGE_REQUEST_EXCLUSIVITY_SPEND_REMINDER_MODAL_TYPE =
  "requestExclusivitySpendReminder";
export const BRAND_PAGE_STORY_MODAL_TYPE = "story";
export type BrandPageQueryObj = {
  /** referrer category  */
  refC?: string;
  /** referrer search  */
  refS?: string;
  /** referrer filters */
  refF?: string[];
  /** referrer products - used to sort specific products to the first positions */
  refP?: string[];
  /** pass referrer category (refC) as sorting hint */
  sortingHint?: boolean;
  /*
   * search query
   */
  q?: string;
  cat?: string;
  sortBy?: keyof typeof ISearchMakerProductsRequest.SortBy;
  page?: number;
  filters?: string[];

  /*
   * other
   */
  product?: string;
  scrollToGrid?: boolean;
  collections?: boolean;
  about?: boolean;
  reorder?: string;
  minimumAmountFooter?: boolean;

  /** source token suitable to be appended to event track path in order to log the link source */
  trackEventToken?: string;

  //** generalized referrer information used for linking searches to search suggestions */
  refType?: string;
  refReqId?: string;

  impressionId?: string;
  highlightedCollection?: string;
  sampleInvite?: string;

  fc?: string;
};

export function parseBrandPageQueryObj(
  locationSearch?: string
): BrandPageQueryObj {
  if (!locationSearch) {
    return {};
  }

  const queryObj = qs.parse(locationSearch);
  if (typeof queryObj.refF === "string") {
    queryObj.refF = [queryObj.refF];
  }
  if (typeof queryObj.refP === "string") {
    queryObj.refP = [queryObj.refP];
  }
  // checking the type to avoid a fatal error if filters is duplicated in the url
  if (queryObj.filters && typeof queryObj.filters === "string") {
    queryObj.filters = splitFiltersFromQueryParamString(queryObj.filters) ?? [];
  }
  return {
    ...queryObj,
    sortingHint: parseBoolean(queryObj.sortingHint),
    scrollToGrid: parseBoolean(queryObj.scrollToGrid),
    collections: parseBoolean(queryObj.collections),
    minimumAmountFooter: parseBoolean(queryObj.minimumAmountFooter),
    page: parsePageNumber(queryObj.page),
  };
}

function parsePageNumber(page: unknown) {
  if (typeof page === "string") {
    const pageNumber = parseInt(page, 10);
    if (isFinite(pageNumber)) {
      return pageNumber;
    }
  }
  return undefined;
}

function parseBoolean(value: unknown): boolean | undefined {
  if (value === undefined || value === null) {
    return undefined;
  } else {
    return Boolean(value);
  }
}
